<template>
  <div class="price-detail">
    <div class="breadcrumb" style="background: #fff">查看特殊价格</div>
    <div class="third-title"><span> SKU组价格信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="specialPriceVo" label-width="100px">
        <el-form-item label="平台号:">
          <span>{{specialPriceVo.storeCode}}</span>
        </el-form-item>
        <el-form-item label="申请价格:">
          <el-button style="margin: 0 0 20px 10px" @click="isEdit = true, $forceUpdate()" type="primary" round>修改</el-button>
        </el-form-item>
        <el-form-item v-if="isEdit" label="申请方式:">
          <el-radio v-model="editSpecialPriceVo.applyType" label="APPLY_BASE">基础P申请</el-radio>
          <el-radio v-model="editSpecialPriceVo.applyType" label="APPLY_DISCOUNT">整体折扣</el-radio>
        </el-form-item>
        <el-form-item label="">
          <el-table v-if="editSpecialPriceVo.applyType === 'APPLY_BASE'" :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column min-width="100px" prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePage" min-width="100px" label="基础P数" v-if="$route.query.spuProperty!=='NORMAL'"></el-table-column>
            <el-table-column prop="maxPage" min-width="100px" label="最大P数" v-if="$route.query.spuProperty!=='NORMAL'"></el-table-column>
            <el-table-column prop="baseStep" min-width="150px" label="一次增加P数" v-if="$route.query.spuProperty!=='NORMAL'"></el-table-column>
            <el-table-column prop="basePagePrice" min-width="150px" :label="$route.query.spuProperty!=='NORMAL'?'基础P平台价格':'基础价格'"></el-table-column>
            <el-table-column prop="baseStepPrice" min-width="150px" label="增加一次平台价格" v-if="$route.query.spuProperty!=='NORMAL'"> </el-table-column>
            <el-table-column min-width="200px" label="申请基础价格" v-show="isEdit" prop="price">
              <template slot-scope="scope">
                <el-input @input="inputr(scope)" :disabled='!isEdit' v-model="scope.row.price" placeholder=""></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-if="editSpecialPriceVo.applyType === 'APPLY_DISCOUNT'" :data="specialPriceVo.specialPriceItemList" border width="100%">
            <el-table-column prop="skuName" label="SKU名称"></el-table-column>
            <el-table-column prop="basePage" v-if="$route.query.spuProperty!=='NORMAL'" label="基础P数"></el-table-column>
            <el-table-column prop="maxPage" v-if="$route.query.spuProperty!=='NORMAL'" label="最大P数"></el-table-column>
            <el-table-column prop="baseStep" v-if="$route.query.spuProperty!=='NORMAL'" label="一次增加P数"></el-table-column>
            <el-table-column prop="basePagePrice" label="基础平台价格"></el-table-column>
            <el-table-column prop="basePagePrice" label="申请平台价格">
              <template slot-scope="scope">
                {{scope.row.basePagePrice*scope.row.price}}
              </template>
            </el-table-column>
            <el-table-column prop="baseStepPrice" v-if="$route.query.spuProperty!=='NORMAL'" label="增加一次平台价格"> </el-table-column>
            <el-table-column prop="baseStepPrice" v-if="$route.query.spuProperty!=='NORMAL'" label="申请增加一次平台价格">
              <template slot-scope="scope">
                <span>{{scope.row.baseStepPrice*scope.row.price}}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请折扣" prop="price">
              <template slot-scope="scope">
                <el-input v-model="scope.row.price" placeholder="" :disabled='!isEdit'></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button v-if="!isEdit" @click="$router.go(-1)" round type="primary">返回</el-button>
      <el-button v-if="isEdit" @click="check" round type="primary">申请特殊价格</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
  </div>
</template>
 <script>
import CombinedDialog from '@/components/Dialog/CombinedDialog/index'
import { skuSpecialGet, skuSpecialUpdate } from '@/api/pms'
export default {
  name: 'price-detail',
  components: {
    CombinedDialog
  },
  data () {
    return {
      isShow: false,
      basicInfo: {},
      isEdit: false,
      specialPriceVo: {
        applyType: '1',
        specialPriceItemList: [
          {
            id: 120002,
            price: 0.8,
            basePage: 14,
            basePagePrice: 24,
            baseStep: '21',
            baseStepPrice: 231,
            maxPage: '23',
            skuName: 'nbSKU组214/23'
          },
          {
            id: 120003,
            price: 0.8,
            basePage: 14,
            basePagePrice: 24,
            baseStep: '21',
            baseStepPrice: 231,
            maxPage: '23',
            skuName: 'nbSKU组214/23'
          }
        ]
      },
      editSpecialPriceVo: {
        applyType: 0,
        specials: []
      }
    }
  },
  created () {
    this.getSpecialMsg()
  },
  methods: {
    inputr (scope) {
      ;
      this.editSpecialPriceVo.specials[scope.$index].price = scope.row.price
    },
    check () {
      skuSpecialUpdate({ specialId: this.$route.query.id, specialPriceVo: this.editSpecialPriceVo }).then(res => {
        ;
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    },
    // 获取特殊价格详情
    getSpecialMsg () {
      skuSpecialGet(this.$route.query.id).then(res => {
        ;
        if (res.data.success) {
          this.specialPriceVo = res.data.data
          this.editSpecialPriceVo.applyType = res.data.data.applyType
          this.specialPriceVo.specialPriceItemList.forEach(item => {
            this.editSpecialPriceVo.specials.push({ price: item.price, skuId: item.skuId })
          })
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
